<style lang="less">

</style>

<template>
  <div class="doc hide-summary show-nav">
    <page-header></page-header>
    <page-search v-if="false"></page-search>
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import pageHeader from '@/components/page-header'
  import pageSearch from '@/components/page-search'
  export default {
    name: "Main",
    components: {
      pageHeader,
      pageSearch,
    },
    data () {
      return {
      }
    },
    computed: {
    },
    created () {
    },
  }
</script>
